import { MeterType } from '@lib-ui/client';

interface MeterProperty {
  displayName: string;
  canAnalyseImage: boolean;
  hasObisCode: boolean;
  unitString?: string;
}

export const MeterProperties = new Map<number, MeterProperty>([
  [MeterType.Electric, { displayName: 'Strom', canAnalyseImage: true, hasObisCode: true }],
  [MeterType.Gas, { displayName: 'Gas', canAnalyseImage: true, hasObisCode: true }],
  [MeterType.Water, {
    displayName: 'Wasser',
    canAnalyseImage: true,
    hasObisCode: false,
    unitString: 'Liter',
  }],
  [MeterType.FuelOil, {
    displayName: 'Heizöl',
    canAnalyseImage: false,
    hasObisCode: false,
    unitString: 'Liter',
  }],
  [MeterType.Heat, {
    displayName: 'Wärme',
    canAnalyseImage: true,
    hasObisCode: false,
    unitString: 'kWh',
  }],
  [MeterType.Undefined, { displayName: '', canAnalyseImage: false, hasObisCode: false }],
]);
